export default function FormatDecimalOddsDescription() {
    return (
        <>
            <p>
                The <b>formatDecimalOdds</b> function returns the value of the
                rawOdds in a decimal odds format
            </p>
            <p>
                The input parameter is an object with key rawOdds and the value
                of the odds coming from the APIs (usually the decimal odds
                multiplied by 1000)
            </p>
            <div>
                The expected output is:
                <ol>
                    <li>
                        A decimal number with 2 decimals when rawOdds/1000 is
                        less than 100
                    </li>
                    <li>
                        A decimal with one number when rawOdds/1000 is between
                        100 and 1000
                    </li>
                    <li>
                        A number with no decimals for rawOdds/1000 greater than
                        1000
                    </li>
                    <li>
                        It should return -1 when rawOdds are -1, corresponding
                        to starting price in racing
                    </li>
                </ol>
            </div>
        </>
    );
}
